// Centralized configuration for CVify
// In production (cvify.tech), API calls use relative paths ('') so they route to the same origin seamlessly.
// In local development (localhost:3000), it automatically targets http://127.0.0.1:8000.
// You can also override this by setting REACT_APP_API_URL in a .env file.

const isLocalhost = Boolean(
  typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
  )
);

export const API_BASE_URL = 
  process.env.REACT_APP_API_URL !== undefined
    ? process.env.REACT_APP_API_URL
    : (isLocalhost ? 'http://127.0.0.1:8000' : '');

export const APP_NAME = "CVify";
export const DOMAIN_NAME = "cvify.tech";
export const SUPPORT_EMAIL = "info@cvify.tech";
export const SUPPORT_PHONE = "+918877966766";
